// extracted by mini-css-extract-plugin
export var growableInput = "_5g-0";
export var tagContainer = "_5g-2";
export var textInput = "_5g-1";